import React from 'react'
import { ChartsContextProvider } from './chartsContext'
import { UrlPathContextProvider } from './urlPathContext'

type GlobalContextProps = {
  children: React.ReactNode
}

const GlobalContext = ({ children }: GlobalContextProps) => {
  return (
    <ChartsContextProvider>
      <UrlPathContextProvider>{children}</UrlPathContextProvider>
    </ChartsContextProvider>
  )
}

export default GlobalContext
